import { PURPOSE_OF_TESTING_DATA } from "../Constant";

export const getPurposeOfTestingDisplayName = (val) => {
  const obj = PURPOSE_OF_TESTING_DATA.find((e) => e.value === val);
  if (obj) {
    const { name } = obj;
    return name;
  }
  return "";
};

export const hasPermission = (
  req_permission,
  data = {},
  type = "EVERY",
  from = ""
) => {
  if (data?.is_super_admin) return true;
  else {
    const permissions = data.permissions || [];
    return type === "EVERY"
      ? req_permission.every((perm) => permissions?.includes(perm))
      : req_permission.some((perm) => permissions?.includes(perm));
  }
};

export const isSuperAdmin = (data = {}) => {
  return data?.is_super_admin;
};
